import $c from '@/utils/constants/helper'

export const useTagStore = defineStore('tag', () => {
  const tags = ref<string[]>([])

  const subjects = Object.freeze(['科目一', '科目四', '满分复活', '三力测试', '注销恢复'])

  const carModels = Object.freeze(['C1/C2/C3', 'A2/B2', 'A1/A3/B1', 'D/E/F'])

  const kmSubjects = Object.freeze([...subjects, ...carModels])

  const topics = computed(() => tags.value.filter(item => !kmSubjects.includes(item)))

  function _map(tag: string) {
    if (['C1/C2/C3', 'A2/B2', 'A1/A3/B1', 'D/E/F'].includes(tag))
      return $c.k2v($c._.carModel, tag)
    else
      return tag
  }

  const fetchTags = async () => {
    tags.value = await $fetch<string[]>('/api/kv/tags')
  }

  return { tags, subjects, kmSubjects, carModels, topics, fetchTags, _map }
})
